<i [class]="'me-1 spf-contenttype-icon ri-2x ' + this.getTypedIcon()"></i>